import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'

import type { StoresLinksColumns } from '../types'
import type { MonitoringValidationConfigSpecialCasesDataSource } from '@app/types/dataSource'
import type { Column } from '@app/components/base/Table/types'

const columnTitleMap: Record<keyof StoresLinksColumns, string> = {
  salesOrganizationId: 'Сбытовая организация',
  clusterGroupId: 'Группа кластеров',
  clusterId: 'Кластер',
  competitorNetworkId: 'Сеть конкурента ',
  removeButton: ''
}

const getColumnsOptions = (): Array<Column<StoresLinksColumns>> => {
  const columnKeys = Object.keys(columnTitleMap) as Array<keyof StoresLinksColumns>

  return columnKeys.map(key => {
    const column: Column<StoresLinksColumns> = {
      key,
      width: '25%',
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }

    return column
  })
}

const getColumns = (): Array<Column<MonitoringValidationConfigSpecialCasesDataSource>> =>
  [
    ...getColumnsFromMap<StoresLinksColumns>({
      columnTitleMap,
      options: getColumnsOptions()
    })
  ] as Array<Column<MonitoringValidationConfigSpecialCasesDataSource>>

export default getColumns
